import ctl from '@netlify/classnames-template-literals'
import { ReactNode, useContext } from 'react'
import { OutPortal } from 'react-reverse-portal'
import { MainNav } from '../../../core'
import { CampaignNavPortalTargetContext } from './campaign-nav-context'
import { PortalCampaignNav, PortalCampaignNavProps } from './portal-campaign-nav'

export type CampaignNavProps = {
	children: ReactNode
	activeCampaignNavLink: PortalCampaignNavProps['activeCampaignNavLink']
	fullWidth?: boolean
	whiteBackground?: boolean
}

/**
 * Every campaign page should be wrapped in this component.
 */
export function CampaignNav(
	{
		children,
		activeCampaignNavLink,
		fullWidth = false,
		whiteBackground = false,
	}: CampaignNavProps,
) {
	const { campaignNavTargetNode } = useContext(CampaignNavPortalTargetContext)

	if (!campaignNavTargetNode) {
		throw new Error('No campaign nav target node')
	}

	return (
		<MainNav activeMainNavLink="campaigns">
			<div
				className={ctl(`
                [--campaign-nav-height:100px]
				[--screen-height:calc(100vh_-_var(--main-nav-height)_-_var(--campaign-nav-height))]
                `)}
			>
				<div className="bg-white px-10 sticky top-[var(--main-nav-height)] z-10">
					<div className="h-[1px] bg-grey-100 absolute bottom-0 left-0 right-0" />
					<OutPortal<typeof PortalCampaignNav>
						node={campaignNavTargetNode}
						activeCampaignNavLink={activeCampaignNavLink}
					/>
				</div>
				<div
					className={ctl(`
						min-h-[var(--screen-height)]
						${whiteBackground ? 'bg-white' : 'transparent'}
					`)}
				>
					<div
						className={ctl(`
							min-h-[inherit]
						${fullWidth ? '' : 'w-[min(100%-80px,var(--max-width))] mx-auto'}
					`)}
					>
						{children}
					</div>
				</div>
			</div>
		</MainNav>
	)
}
